import { render, staticRenderFns } from "./NewProductEntry.vue?vue&type=template&id=38f96fc4&"
import script from "./NewProductEntry.vue?vue&type=script&lang=js&"
export * from "./NewProductEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewProductEntry.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewProductEntry.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VDivider,VRow,VTab,VTabItem,VTabs,VTabsItems})
